<template>
  <v-dialog max-width="500" v-model="dialog.shows.showDetail">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list two-line>
          <v-list-item v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])">
            <v-list-item-icon>
              <v-icon color="secondary">mdi-account-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.user }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.user.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])"></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-code-string</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.shortName }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.shortName.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-account-card-details-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.name.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-at</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.email }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.email.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-flag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ getNotificationLabel(form.notificationActive) }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.notificationActive.title2') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-flag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ getNotificationLabel(form.notificationEmailActive) }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.notificationEmailActive.title2') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-flag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ getActiveLabel(form.active) }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.active.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-key</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.apiKey }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.apiKey.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-textbox-password</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.secret }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.secret.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-note-text</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{ form.description }}</v-list-item-title>
              <v-list-item-subtitle>{{ $vuetify.lang.t('$vuetify.application.cols.description.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog.shows.showDetail = false" text>{{ $vuetify.lang.t('$vuetify.btn.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.application.new.title",
            shows: {
              showDetail: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      },
      form: {
        type: Object,
        default: function () {
          return {
            name: null,
            shortName: null,
            description: null,
            user: null,
            email: null
          };
        }
      }
    },
    methods: {
      setForm(item) {
        this.form["id"] = item.id;
        this.form.user = (this._.has(item, 'userId')) ? item.user.username : this.$auth.user().username;
        this.form["apiKey"] = item.apiKey;
        this.form["secret"] = item.secret;
        this.form["notificationActive"] = item.notificationActive;
        this.form["notificationEmailActive"] = item.notificationEmailActive;
        this.form["active"] = item.active;
        this.form.name = item.name;
        this.form["oldName"] = item.name;
        this.form.shortName = item.shortName;
        this.form.description = item.description;
        this.form.email = item.email;
      },
      getNotificationLabel(notification) {
        if (notification) return this.$vuetify.lang.t('$vuetify.application.cols.notificationActive.enable.title2');
        return this.$vuetify.lang.t('$vuetify.application.cols.notificationActive.disable.title2');
      },
      getActiveLabel(status) {
        if (status) return this.$vuetify.lang.t('$vuetify.application.cols.active.enable.title2');
        return this.$vuetify.lang.t('$vuetify.application.cols.active.disable.title2');
      }
    }
  };
</script>

<style scoped>
  >>> .v-list-item__title {
    white-space: initial;
  }
</style>
